import React from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CourseCard from "examples/Cards/CourseCard";
import AusbildungCard from "examples/Cards/AusbildungsCard";
import AddBuyerPopup from "examples/Popups/AddBuyer";

import MongoHandler from "services/mongoHandler";
import TokenFunctions from "functions/tokenFunctions";
import { useNavigate } from 'react-router-dom';

import SimplePopup from "examples/Popups/SimplePopup";

function Courses() {
  const [products, setProducts] = React.useState([]);
  const [dates, setDates] = React.useState([]);
  const [displayedBuyer, setDisplayedBuyer] = React.useState(null);
  const [displayedDate, setDisplayedDate] = React.useState(null);
  const [displayedDay, setDisplayedDay] = React.useState("Samstag");
  const [displayedBuyerAusbildung, setDisplayedBuyerAusbildung] = React.useState(null);

  const mongoHandler = new MongoHandler();
  const tokenFunctions = new TokenFunctions();
  const navigate = useNavigate();

  const loadProducts = async (type) => {
    const tempProducts = await mongoHandler.getFilteredProducts(type);
    createDateArray(tempProducts);
    setProducts(tempProducts);
    console.log(tempProducts);
    
  };

  React.useEffect(() => {
    loadProducts("course");

    if (!tokenFunctions.refreshToken()) {
      navigate('/authentication/sign-in/simple');
    }
    
  }, []);

  const updateProducts = async (body, productIndex) => {
    // Send patch request to update the product in the database
    await mongoHandler.updateProduct(body.productId, body);
    // Update the local state to reflect the change
    setProducts((prevProducts) =>
      prevProducts.map((product, index) =>
        index === productIndex ? body : product
      )
    );
    console.log(`Product ${body.productId} updated successfully.`);
  } 

  const createDateArray = (items) => {
    const tempDates = [];
    items.forEach((item) => {
      let itemDates = []
      item.properties[0].dates.forEach((prop) => {
        itemDates.push(prop.date);
      })
      tempDates.push(itemDates);
    })
    setDates(tempDates);
    console.log(tempDates);
    
    setDisplayedDate(tempDates[0][0]);
    setDisplayedDay(tempDates[1][0]);
  }

  const updateCourse = async (body, courseIndex) => {
    // Send patch request to update the product in the database
    await mongoHandler.updateProduct(body.productId, body);
    // Update the local state to reflect the change
    setProducts((prevProducts) => {
      const updatedProducts = prevProducts.map((product, index) =>
        index === courseIndex ? body : product
      );
      
      // Recreate the Date array after the update
      createDateArray(updatedProducts);
      
      return updatedProducts;
    });
    console.log(`Product ${body.productId} updated successfully.`);
  }

  const changeBuyer = async (buyerId) => {
    if (buyerId === "") {
      setDisplayedBuyer(null);
    } else {
      const tempDisplayedBuyer = await mongoHandler.getBuyerById(buyerId);
      setDisplayedBuyer(tempDisplayedBuyer[0]);
    }
  }

  const changeBuyerAusbildung = async (buyerId) => {
    if (buyerId === "") {
      setDisplayedBuyerAusbildung(null);
    } else {
      const tempDisplayedBuyer = await mongoHandler.getBuyerById(buyerId);
      setDisplayedBuyerAusbildung(tempDisplayedBuyer[0]);
    }
  }

  const addDate = async (newDate, courseIndex) => {
    setDisplayedDate(newDate);
    // Get the product to update
    const productToUpdate = { ...products[courseIndex] };

    productToUpdate.properties[0].dates.push(newDate);
    // Sort the dates array by date in ascending order
    productToUpdate.properties[0].dates.sort((a, b) => {
      const dateA = new Date(a.date.split('.').reverse().join('-')); // Convert "dd.mm.yyyy" to "yyyy-mm-dd"
      const dateB = new Date(b.date.split('.').reverse().join('-')); // Convert "dd.mm.yyyy" to "yyyy-mm-dd"
      return dateA - dateB;
  });

    await updateCourse(productToUpdate, courseIndex);
  }

  const deleteDate = async (courseIndex, dateIndex) => {
    setDisplayedDate(null);
    // Get the product to update
    const productToUpdate = { ...products[courseIndex] };

    // Remove the date at the specified index
    productToUpdate.properties[0].dates.splice(dateIndex, 1);

    await updateCourse(productToUpdate, courseIndex);
  }

  const addBuyer = async (newBuyer, courseIndex, dateIndex) => {    
    // Get the product to update
    const productToUpdate = { ...products[courseIndex] };
    // Update the reserved list
    const updatedDates = productToUpdate.properties[0].dates.map((date, index) => {
      if (index === dateIndex) {
        // Create a new reserved array with the new buyerId
        const updatedReserved = [...(date.reserved || []), newBuyer.buyerId];
        return {
          ...date,
          reserved: updatedReserved, // Update the reserved array
        };
      }
      return date; // Return the date unchanged for other indices
    });
    // Assign the updated dates back to the product
    productToUpdate.properties[0].dates = updatedDates;
    // Update the product in the database and local state
    await updateCourse(productToUpdate, courseIndex);
    await mongoHandler.createBuyer(newBuyer);
  }

  const deleteBuyer = async (id, courseIndex, dateIndex) => {
    // Get the product to update
    const productToUpdate = { ...products[courseIndex] };
    // Update the reserved list
    const updatedDates = productToUpdate.properties[0].dates.map((date, index) =>
      index === dateIndex
        ? {
          ...date,
          reserved: (() => {
            const reservedCopy = [...date.reserved];
            const indexToRemove = reservedCopy.indexOf(id);
            if (indexToRemove !== -1) {
              reservedCopy.splice(indexToRemove, 1); // Remove only the first occurrence
            }
            return reservedCopy;
          })(),
        }
        : date
    );
    // Assign the updated dates back to the product
    productToUpdate.properties[0].dates = updatedDates;
    // Check if the id still exists in any date's reserved list
    const idExistsInReserved = productToUpdate.properties[0].dates.some((date) =>
      date.reserved.includes(id)
    );
    // Update the product in the database and local state
    await updateCourse(productToUpdate, courseIndex);
    // Only delete the buyer if the id no longer exists in the reserved list
    if (!idExistsInReserved) {
      await mongoHandler.deleteBuyer(id);
    }
    changeBuyer("")
  }

  const deleteBuyerAusbildung = async (id, courseIndex, dateIndex) => {
    // Get the product to update
    const productToUpdate = { ...products[courseIndex] };
    // Update the reserved list
    const updatedDates = productToUpdate.properties[0].dates.map((date, index) =>
      index === dateIndex
        ? {
          ...date,
          reserved: (() => {
            const reservedCopy = [...date.reserved];
            const indexToRemove = reservedCopy.indexOf(id);
            if (indexToRemove !== -1) {
              reservedCopy.splice(indexToRemove, 1); // Remove only the first occurrence
            }
            return reservedCopy;
          })(),
        }
        : date
    );
    // Assign the updated dates back to the product
    productToUpdate.properties[0].dates = updatedDates;
    // Check if the id still exists in any date's reserved list
    const idExistsInReserved = productToUpdate.properties[0].dates.some((date) =>
      date.reserved.includes(id)
    );
    // Update the product in the database and local state
    await updateCourse(productToUpdate, courseIndex);
    // Only delete the buyer if the id no longer exists in the reserved list
    if (!idExistsInReserved) {
      await mongoHandler.deleteBuyer(id);
    }
    changeBuyerAusbildung("")
  }

  const handleDateChange = (index) => {
    setDisplayedDate(dates[0][index])
  }

  const handleDayChange = (index) => {
    setDisplayedDay(dates[1][index])
  }

  const updateTotalSpace = async (newValue, productIndex, dateIndex) => {
    try {
      // Find the product to update
      let productToUpdate = products[productIndex];

      productToUpdate.properties[0].dates[dateIndex].totalSpace = newValue;

      // Update the product
      await updateProducts(productToUpdate, productIndex);
    
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* <AppBar position="static">
        <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
          <Tab label="Honig" />
          <Tab label="Getränke" />
        </Tabs>
      </AppBar> */}
      <MDBox>
        <Grid container spacing={3}>
          {products.map((item, index) => (
            <>
              {item.title !== "Kräuterkurs im Jahreskreis" ? (
                <Grid item xs={12} md={6} lg={6}>
                  <CourseCard
                    product={item}
                    index={index}
                    dates={dates}
                    displayedBuyer={displayedBuyer}
                    displayedDate={displayedDate}
                    handleDateChange={handleDateChange}
                    changeBuyer={changeBuyer}
                    addDate={addDate}
                    deleteDate={deleteDate}
                    addBuyer={addBuyer}
                    deleteBuyer={deleteBuyer}
                    updateTotalSpace={updateTotalSpace}
                  />
                </Grid>
            ) : (
              <Grid item xs={12} md={6} lg={6}>
                <AusbildungCard
                  product={item}
                  index={index}
                  dates={dates}
                  displayedBuyer={displayedBuyerAusbildung}
                  displayedDay={displayedDay}
                  handleDayChange={handleDayChange}
                  changeBuyerAusbildung={changeBuyerAusbildung}
                  addBuyer={addBuyer}
                  deleteBuyer={deleteBuyerAusbildung}
                  updateTotalSpace={updateTotalSpace}
                />
              </Grid>
            )}
            </>
          ))}
        </Grid>
      </MDBox>
    </DashboardLayout>
  )
}

export default Courses;